import React, { createContext, useState, useEffect, useRef } from "react";
import { IGeneralTermsContext } from "../types/generalTerms";
import { generalTermsService } from "../api/generalTermsService/generalTermsService";
import { toast } from "react-toastify";
import { IsAuthorized } from "../utils/helpers/auth";
import { useTranslation } from "react-i18next";

export const GeneralTermsContext = createContext<null | IGeneralTermsContext>(null);

interface Props {
    children: React.ReactNode
}

export const GeneralTermsProvider: React.FC<Props> = ({ children }) => {
    const { t } = useTranslation();

    const [hasAcceptedDriversRules, setHasAcceptedDriversRules] = useState(false);
    const [driversRulesDocument, setDriversRulesDocument] = useState<string | null>(null);
    const [driversRulesDescription, setDriversRulesDescription] = useState<string | null>(null);
    const [hasAcceptedGeneralTerms, setHasAcceptedGeneralTerms] = useState(false);
    const [generalTermsDocument, setGeneralTermsDocument] = useState<string | null>(null);
    const [generalTermsDescription, setGeneralTermsDescription] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    const canGo = useRef(true);
    useEffect(() => {
        if (canGo.current === true) {
            canGo.current = false;

            if (IsAuthorized()) {
                checkGeneralTerms();
            }
        }
    }, []);

    const checkGeneralTerms = async () => {
        setLoading(true);
        const response = await generalTermsService.getGeneralTerms();
        if (response.success) {
            setHasAcceptedGeneralTerms(response.responseBody.generalTerms.accepted);
            setGeneralTermsDocument(response.responseBody.generalTerms.documentBody);
            setGeneralTermsDescription(response.responseBody.generalTerms.description);

            setHasAcceptedDriversRules(response.responseBody.duvri.accepted);
            setDriversRulesDocument(response.responseBody.duvri.documentBody);
            setDriversRulesDescription(response.responseBody.duvri.description);
        } else {
            toast.error(t('errors.errorCheckingGeneralTerms'));
        }

        setLoading(false);
    }

    const value: IGeneralTermsContext = {
        hasAcceptedDriversRules,
        setHasAcceptedDriversRules,
        hasAcceptedGeneralTerms,
        setHasAcceptedGeneralTerms,
        loading,
        setLoading,
        driversRulesDocument,
        generalTermsDocument,
        driversRulesDescription,
        generalTermsDescription
    };

    return (
        <GeneralTermsContext.Provider
            value={value}
        >
            {children}
        </GeneralTermsContext.Provider>
    );
};